import { CommonToggleButtonProps, StandardToggleButton } from './TooggleButton'

const NotesIconButton: React.FC<CommonToggleButtonProps> = ({ id, active, disabled, onClick }) => (
    <StandardToggleButton
        id={id}
        color={active ? 'primary' : 'secondary'}
        icon={ 'NotesRounded'}
        disabled={disabled}
        onClick={onClick}
        selected={active}
    />
)

export { NotesIconButton }
